import './polyfills/customElements'
import './polyfills/closest'
import './polyfills/remove'

import setDeviceClasses from './setDeviceClasses/setDeviceClasses'

import './onError/client/devmode'

setDeviceClasses()
